import { Component, OnInit } from '@angular/core';
import {Course} from "../../courses/shared/course";
import {ObjectObservable} from "../../shared/base/object-observable";
import {User} from "../shared/user";
import {UserService} from "../shared/user.service";
import {AngularFireAuth} from "angularfire2/auth";
import {CourseService} from "../../courses/shared/course.service";
import {CourseUserService} from "../../courses/shared/course-user.service";
import {NavService} from "../../core/nav.service";

@Component({
  selector: 'app-user-courses',
  templateUrl: './user-courses.component.html',
  styleUrls: ['./user-courses.component.scss']
})
export class UserCoursesComponent implements OnInit {
  private userObservable: ObjectObservable<User>;
  courses: Course[] = [];

  constructor(
    private nav: NavService,
    private userService: UserService,
    private afAuth: AngularFireAuth,
    private courseService: CourseService,
    private courseUserService: CourseUserService) {
  }

  ngOnInit() {

    // this.initNav();
    this.nav.title = '프로필';
    this.afAuth.authState.subscribe(auth => {
      if (auth) {
        this.userObservable = this.userService.readChild(auth.uid);
        this.courseService.list.subscribe(courses => {
          courses.map(course => {
            this.courseUserService.readUser({$key: course.$key}).subscribe(user => {
              if (user.state) {
                course.ownerObservable = this.userService.readChild(course.owner);
                return this.courses.push(course);
              }
            });
          });
        });
      }
    });
  }

  private initNav(): void {
    // this.nav.title = '프로필';
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/user-courses/user-courses.component.ts